import { render, staticRenderFns } from "./role-permissions.vue?vue&type=template&id=6d1eb2c0&scoped=true&"
import script from "./role-permissions.vue?vue&type=script&lang=js&"
export * from "./role-permissions.vue?vue&type=script&lang=js&"
import style0 from "./role-permissions.vue?vue&type=style&index=0&id=6d1eb2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1eb2c0",
  null
  
)

export default component.exports